import { useCallback, useEffect, useState } from "react";
import { Banner, BlockStack, Button, Card, InlineGrid, Link, Text } from "@shopify/polaris";
import { authenticatedFetch } from "../api";
import type { ProductCountsResponse } from "../types";

export function ProductCounts() {
	const [data, setData] = useState<ProductCountsResponse | null>(null);
	const [failed, setFailed] = useState(false);
	const refresh = useCallback(async () => {
		try {
			setData(await authenticatedFetch<ProductCountsResponse>("/api/products/counts"));
			setFailed(false);
		} catch { setData(null); setFailed(true); }
	}, []);
	useEffect(() => { refresh(); }, [refresh]);
	const labels = data?.triggerMode === "sync-safe"
		? { all: "All products", pending: "Enrolled · incomplete", translated: "Enrolled · complete", untranslated: "Not enrolled" }
		: { all: "All products", pending: "Pending translation", translated: "Translated", untranslated: "Not translated" };
	return <BlockStack gap="300">
		<Text variant="headingMd" as="h2">Product translation status</Text>
		{failed && <Banner tone="critical" title="Product counts unavailable"><Button onClick={refresh}>Retry</Button></Banner>}
		<InlineGrid columns={{ xs: 1, sm: 2, md: 4 }} gap="400">
			{Object.entries(labels).map(([status, label]) => <Card key={status}>
				<BlockStack gap="200">
					<Link url={`/products?status=${status}`}>{label}</Link>
					<Text variant="headingLg" as="p">{failed ? "Unavailable" : data ? `${data.counts[status].precision === "AT_LEAST" ? "≥" : ""}${data.counts[status].count.toLocaleString("en-GB")}` : "Loading…"}</Text>
				</BlockStack>
			</Card>)}
		</InlineGrid>
		{data?.triggerMode === "sync-safe" && <Text as="p" tone="subdued">Counts follow translation tags. A push during the day usually shows here within 1.5 hours; a push in the evening shows the next morning. Open a list to see each product’s verified {data.statusLocale?.toUpperCase()} translation.</Text>}
	</BlockStack>;
}
